
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const Classes = createAsyncThunk('staff-list', async ({searchParams,branch_id,Endkey}) => {
    let res = await dataService.GetAPI(`${Endkey}?branch_id=${branch_id.toString()}&${(searchParams.toString())}`);
    return res
})
const ClassesSlice = createSlice({

    name: 'Classes-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [Classes.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [Classes.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [Classes.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = ClassesSlice.actions;
export default ClassesSlice.reducer